export const heroLead = {
  id: "lead",
  category: "本周主推合集",
  title: "顶流工作室内讧风波 · 全时间线合集",
  excerpt:
    "从一句状态更新到双方声明，48 小时内的全部动态按时间顺序整理完毕，含前后对比与关键节点标注，翻一遍就能看懂来龙去脉。",
  image:
    "https://readdy.ai/api/search-image?query=Cinematic%20abstract%20stage%20with%20warm%20amber%20spotlight%20beams%20cutting%20through%20haze%20in%20a%20dark%20empty%20venue%2C%20deep%20charcoal%20and%20burnt%20orange%20tones%2C%20dramatic%20side%20lighting%2C%20subtle%20film%20grain%2C%20minimalist%20editorial%20photography%2C%20no%20people%2C%20high%20detail&width=1200&height=740&seq=lieqiu-hero-lead&orientation=landscape",
  tags: ["时间线梳理", "双方声明", "老料回锅"],
  meta: { updated: "2 小时前更新", items: 84, heat: "12.6w" },
};

export const heroSideCards = [
  {
    id: "side-1",
    category: "节目话题",
    title: "综艺剪辑争议 · 未播片段整理",
    image:
      "https://readdy.ai/api/search-image?query=Vintage%20condenser%20microphone%20close%20up%20on%20a%20dark%20stage%20with%20warm%20backlight%20glow%2C%20charcoal%20background%2C%20amber%20highlights%2C%20moody%20editorial%20photography%2C%20shallow%20depth%20of%20field%2C%20no%20people%2C%20high%20detail&width=600&height=420&seq=lieqiu-hero-s1&orientation=landscape",
    meta: "126 条 · 3 小时前",
  },
  {
    id: "side-2",
    category: "互动风波",
    title: "评论区互撕 · 截图合并版",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20blurred%20camera%20flash%20lights%20at%20night%2C%20warm%20amber%20and%20crimson%20bokeh%20against%20deep%20charcoal%20darkness%2C%20cinematic%20minimal%20composition%2C%20film%20grain%2C%20no%20people%2C%20high%20detail&width=600&height=420&seq=lieqiu-hero-s2&orientation=landscape",
    meta: "152 条 · 5 小时前",
  },
  {
    id: "side-3",
    category: "资料归档",
    title: "历年老料回锅 · 打包索引",
    image:
      "https://readdy.ai/api/search-image?query=Torn%20newspaper%20texture%20close%20up%20with%20warm%20cream%20paper%20and%20charcoal%20ink%2C%20soft%20raking%20light%2C%20minimal%20editorial%20still%20life%2C%20muted%20amber%20tones%2C%20no%20people%2C%20high%20detail&width=600&height=420&seq=lieqiu-hero-s3&orientation=landscape",
    meta: "209 条 · 昨天更新",
  },
  {
    id: "side-4",
    category: "现场记录",
    title: "舞台事故与放送失误合集",
    image:
      "https://readdy.ai/api/search-image?query=Empty%20backstage%20corridor%20lit%20by%20warm%20amber%20lamps%2C%20deep%20charcoal%20shadows%2C%20cinematic%20one%20point%20perspective%2C%20moody%20editorial%20photography%2C%20no%20people%2C%20high%20detail&width=600&height=420&seq=lieqiu-hero-s4&orientation=landscape",
    meta: "47 条 · 6 小时前",
  },
];

export const heroStats = [
  { label: "今日新增条目", value: "218", unit: "条" },
  { label: "在更合集", value: "36", unit: "个" },
  { label: "活跃话题", value: "1,042", unit: "个" },
  { label: "打包资源", value: "57", unit: "份" },
];

export const collections = [
  {
    id: "c1",
    no: "01",
    title: "顶流恋情风波合集",
    category: "人物事件",
    desc: "同框、行程、回应三线并进，按日期排好序。",
    count: 84,
    updated: "09-10",
  },
  {
    id: "c2",
    no: "02",
    title: "综艺剪辑争议合集",
    category: "节目话题",
    desc: "正片与花絮逐帧对照，标注被剪掉的段落。",
    count: 126,
    updated: "09-10",
  },
  {
    id: "c3",
    no: "03",
    title: "代言解约与商务变动",
    category: "商业动态",
    desc: "品牌动作与官微调整，按先后顺序记录。",
    count: 63,
    updated: "09-09",
  },
  {
    id: "c4",
    no: "04",
    title: "舞台事故与放送失误",
    category: "现场记录",
    desc: "直播与路透双版本对照，标注时间码。",
    count: 47,
    updated: "09-09",
  },
  {
    id: "c5",
    no: "05",
    title: "社交平台互撕合集",
    category: "互动风波",
    desc: "双方的每一条动态与删除记录都留档。",
    count: 152,
    updated: "09-08",
  },
  {
    id: "c6",
    no: "06",
    title: "剧集换角与番位之争",
    category: "剧组动态",
    desc: "立项到定妆的人员变化流程图。",
    count: 71,
    updated: "09-08",
  },
  {
    id: "c7",
    no: "07",
    title: "演唱会退票与风波",
    category: "线下活动",
    desc: "官方公告与现场反馈整理成对照表。",
    count: 38,
    updated: "09-07",
  },
  {
    id: "c8",
    no: "08",
    title: "老料回锅 · 历年合集",
    category: "资料归档",
    desc: "过往被反复提起的旧事，一次性归档。",
    count: 209,
    updated: "09-07",
  },
];

export const topicCategories = ["全部", "人物", "事件", "节目", "商务", "现场", "归档"];

export const topicTags = [
  { name: "恋情风波", heat: 98, category: "人物" },
  { name: "商务解约", heat: 76, category: "商务" },
  { name: "综艺剪辑", heat: 91, category: "节目" },
  { name: "番位之争", heat: 64, category: "事件" },
  { name: "舞台事故", heat: 55, category: "现场" },
  { name: "直播翻车", heat: 82, category: "现场" },
  { name: "评论区互撕", heat: 88, category: "事件" },
  { name: "粉丝控评", heat: 49, category: "事件" },
  { name: "临时换角", heat: 58, category: "节目" },
  { name: "合约到期", heat: 44, category: "商务" },
  { name: "老料回锅", heat: 70, category: "归档" },
  { name: "站姐爆料", heat: 79, category: "人物" },
  { name: "通告变动", heat: 41, category: "商务" },
  { name: "声明回应", heat: 93, category: "事件" },
  { name: "演唱会退票", heat: 52, category: "现场" },
  { name: "品牌公关", heat: 47, category: "商务" },
  { name: "行程疑点", heat: 66, category: "人物" },
  { name: "时间线梳理", heat: 85, category: "归档" },
];

export const feedItems = [
  {
    id: "f1",
    category: "人物事件",
    title: "同款单品被扒了个遍 · 细节对比整理第 3 版",
    excerpt:
      "从帽子到手机壳逐件对照，附上出现时间与场合，争议点集中在其中两件。",
    time: "28 分钟前",
    heat: "3.4w",
    tag: "细节对比",
    image:
      "https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20vintage%20film%20reel%20on%20a%20dark%20table%20with%20warm%20amber%20rim%20light%2C%20charcoal%20background%2C%20minimal%20editorial%20still%20life%2C%20subtle%20grain%2C%20no%20people%2C%20high%20detail&width=480&height=360&seq=lieqiu-feed-1&orientation=landscape",
  },
  {
    id: "f2",
    category: "节目话题",
    title: "录制现场路透流出 · 与正片顺序对不上",
    excerpt: "路透与播出版本顺序差异明显，整理出三段可疑的调换位置。",
    time: "1 小时前",
    heat: "5.1w",
    tag: "剪辑争议",
    image:
      "https://readdy.ai/api/search-image?query=Blurred%20neon%20city%20street%20at%20night%20in%20warm%20amber%20and%20crimson%20tones%2C%20deep%20charcoal%20shadows%2C%20cinematic%20bokeh%2C%20minimal%20composition%2C%20no%20people%2C%20high%20detail&width=480&height=360&seq=lieqiu-feed-2&orientation=landscape",
  },
  {
    id: "f3",
    category: "商业动态",
    title: "官微深夜修改简介 · 品牌动作时间线",
    excerpt: "互动记录与简介改动先后顺序被完整截图，时间点集中在凌晨。",
    time: "2 小时前",
    heat: "2.8w",
    tag: "商务变动",
    image:
      "https://readdy.ai/api/search-image?query=Stack%20of%20brown%20paper%20envelopes%20and%20folded%20documents%20on%20a%20dark%20wooden%20desk%2C%20warm%20amber%20side%20lighting%2C%20charcoal%20background%2C%20minimal%20editorial%20still%20life%2C%20no%20people%2C%20high%20detail&width=480&height=360&seq=lieqiu-feed-3&orientation=landscape",
  },
  {
    id: "f4",
    category: "现场记录",
    title: "舞台走位失误合集 · 含慢放与时间码",
    excerpt: "把几个机位的画面并排放好，逐段标注出错的秒数。",
    time: "3 小时前",
    heat: "1.9w",
    tag: "现场实录",
    image:
      "https://readdy.ai/api/search-image?query=Dramatic%20spotlight%20beams%20crossing%20a%20hazy%20dark%20space%2C%20warm%20amber%20glow%20against%20charcoal%20black%2C%20abstract%20cinematic%20photography%2C%20film%20grain%2C%20no%20people%2C%20high%20detail&width=480&height=360&seq=lieqiu-feed-4&orientation=landscape",
  },
  {
    id: "f5",
    category: "互动风波",
    title: "删帖与补发记录 · 双方动态对照表",
    excerpt: "谁先发、谁先删、谁后补，全部按分钟排在一张表里。",
    time: "4 小时前",
    heat: "4.6w",
    tag: "回应声明",
    image:
      "https://readdy.ai/api/search-image?query=Crumpled%20warm%20cream%20paper%20balls%20on%20a%20charcoal%20surface%20with%20soft%20directional%20light%2C%20minimal%20abstract%20editorial%20still%20life%2C%20muted%20amber%20tones%2C%20no%20people%2C%20high%20detail&width=480&height=360&seq=lieqiu-feed-5&orientation=landscape",
  },
  {
    id: "f6",
    category: "资料归档",
    title: "历年相似事件汇总 · 老料回锅第一包",
    excerpt: "把过去几年被反复提起的同类旧事排在一起，方便横向对比。",
    time: "6 小时前",
    heat: "3.1w",
    tag: "打包归档",
    image:
      "https://readdy.ai/api/search-image?query=Old%20archive%20storage%20boxes%20stacked%20in%20a%20dim%20room%20with%20warm%20amber%20light%2C%20charcoal%20shadows%2C%20cinematic%20minimal%20composition%2C%20film%20grain%2C%20no%20people%2C%20high%20detail&width=480&height=360&seq=lieqiu-feed-6&orientation=landscape",
  },
];

export const hotRank = [
  { rank: 1, title: "工作室深夜发声 · 全文逐句拆解", heat: "14.2w" },
  { rank: 2, title: "同框照片时间地点已对上", heat: "12.6w" },
  { rank: 3, title: "综艺剪辑争议 · 未播片段整理", heat: "9.8w" },
  { rank: 4, title: "品牌官微互动记录被截图", heat: "8.1w" },
  { rank: 5, title: "站姐发文后秒删 · 备份整理", heat: "7.4w" },
  { rank: 6, title: "评论区互撕 · 截图合并版", heat: "6.3w" },
  { rank: 7, title: "演唱会退票公告与现场反馈", heat: "5.2w" },
  { rank: 8, title: "剧集换角流程图最新版", heat: "4.7w" },
];

export const latestUpdates = [
  { title: "新增「行程疑点」条目 6 条", time: "12 分钟前" },
  { title: "「综艺剪辑争议」补充花絮对照", time: "48 分钟前" },
  { title: "打包资源第 57 份已整理完成", time: "2 小时前" },
  { title: "「老料回锅」归档编号重排", time: "4 小时前" },
  { title: "话题墙上新 12 个关键词", time: "6 小时前" },
  { title: "合集「剧集换角」更新流程图", time: "昨天 22:40" },
];

export const timelineEvents = [
  {
    date: "09-06",
    tag: "起点",
    title: "一条状态更新引发讨论",
    desc: "当晚动态被大量转存，相关话题首次进入榜单。",
  },
  {
    date: "09-07",
    tag: "发酵",
    title: "双方粉丝开始整理时间线",
    desc: "多个版本的对照表同日出现，细节开始互相印证。",
  },
  {
    date: "09-08",
    tag: "转折",
    title: "品牌方调整官微互动",
    desc: "简介与互动记录先后改动，被截图留档。",
  },
  {
    date: "09-09",
    tag: "回应",
    title: "工作室发布正式说明",
    desc: "说明发布后，话题热度短时冲上榜单前列。",
  },
  {
    date: "09-10",
    tag: "归档",
    title: "全流程合集整理完成",
    desc: "按日期排好序的完整合集上线，含前后对比。",
  },
];

export const packResources = [
  {
    id: "p1",
    title: "本周热门黑料打包 · 第 57 期",
    format: "整理包",
    size: "1.2 GB",
    downloads: "3.4w",
    updated: "09-10 08:20",
    desc: "本周全部新增条目按话题分类放好，附目录索引页。",
    image:
      "https://readdy.ai/api/search-image?query=Cardboard%20archive%20boxes%20with%20labels%20on%20a%20dark%20floor%2C%20warm%20amber%20light%20from%20the%20side%2C%20charcoal%20background%2C%20minimal%20editorial%20still%20life%2C%20no%20people%2C%20high%20detail&width=560&height=380&seq=lieqiu-pack-1&orientation=landscape",
  },
  {
    id: "p2",
    title: "老料回锅合集 · 历年归档包",
    format: "归档包",
    size: "2.6 GB",
    downloads: "5.1w",
    updated: "09-09 21:05",
    desc: "把历年同类旧事一次性归档，按年份与话题双重排序。",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20glowing%20digital%20file%20icons%20floating%20in%20dark%20space%2C%20warm%20amber%20and%20crimson%20glow%2C%20charcoal%20background%2C%20minimal%20tech%20editorial%20visual%2C%20no%20people%2C%20high%20detail&width=560&height=380&seq=lieqiu-pack-2&orientation=landscape",
  },
  {
    id: "p3",
    title: "图文证据整理包 · 时间线版",
    format: "图文包",
    size: "860 MB",
    downloads: "2.7w",
    updated: "09-08 18:40",
    desc: "每条都带上时间与来源说明，适合按顺序完整翻看。",
    image:
      "https://readdy.ai/api/search-image?query=Vintage%20hard%20drive%20and%20folders%20on%20a%20dark%20desk%20with%20warm%20amber%20rim%20light%2C%20charcoal%20background%2C%20minimal%20editorial%20still%20life%2C%20subtle%20grain%2C%20no%20people%2C%20high%20detail&width=560&height=380&seq=lieqiu-pack-3&orientation=landscape",
  },
];

export const navLinks = [
  { label: "首页", href: "#top" },
  { label: "合集索引", href: "#collections" },
  { label: "话题墙", href: "#topics" },
  { label: "最新整理", href: "#feed" },
  { label: "打包专区", href: "#packs" },
];

export const footerIndexGroups = [
  {
    title: "合集索引",
    links: ["顶流恋情风波", "综艺剪辑争议", "代言解约变动", "舞台事故记录"],
  },
  {
    title: "话题分类",
    links: ["人物", "事件", "节目", "商务"],
  },
  {
    title: "资料专区",
    links: ["打包资源", "历年归档", "时间线梳理", "免责声明"],
  },
];